import React from 'react';
import Header from './components/header'
import RecipeSearchBar from './components/RecipeSearchBar'
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <RecipeSearchBar />
    </div>
  );
}

export default App;
